<template>
  <page-status :loading="loading">
    <search-layout class="proposal-auth" :header="!type ? '短信验证' : ''">
      <div v-if="!!type" slot="header" class="header">
        根据当地行业监管规定，车险支付需对您的手机号进行短信验证！
      </div>
      <div class="auth-content">
        <div class="auth-title">我们将发送短信验证码到你的手机号</div>
        <div class="auth-mobile">
          {{ mobile.slice(0, 3) + '****' + mobile.slice(7, 13) }}
        </div>
        <div class="verify-code">
          <van-password-input
            :gutter="16"
            :mask="false"
            :length="smsMaxLength"
            :value="code"
            :focused="focused"
          />
          <input
            class="input-code"
            type="tel"
            :maxlength="smsMaxLength"
            v-model="code"
            @focus="focused = true"
            @blur="focused = false"
          />
        </div>
        <div v-if="canSend" class="send-code active" @click="handleSend()">
          发送验证码
        </div>
        <div v-else class="send-code">
          <van-count-down
            ref="countDown"
            :time="smsSecond"
            format="ss"
            @finish="handleFinish()"
          />
          <span>秒后重新发送</span>
        </div>
      </div>
    </search-layout>
  </page-status>
</template>

<script>
import { Toast } from 'vant';
import SearchLayout from '@/layouts/SearchLayout';
import PageStatus from '@/components/PageStatus';
import * as services from '@/services';
import { bindRecord } from '@/core/recorder';

export default {
  components: {
    SearchLayout,
    PageStatus,
  },

  data() {
    return {
      loading: true,
      mobile: '',
      smsAuthNo: '',
      smsMaxLength: 4,
      smsSecond: 120000,
      canSend: true,
      focused: false,
      code: '',
      type: '',
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    const { query } = this.$route;
    const { businessNo, mobile } = query;

    // 绑定用户
    if (businessNo && mobile) {
      bindRecord({ userId: businessNo + '_' + mobile });
    }

    window.localStorage.setItem(`${businessNo}`, window.location.href);
    services.authShift(businessNo).then(res => {
      const { content } = res;
      const { signUrl, signStatus, original } = JSON.parse(content);
      if (original === '1') {
        return;
      } else if (signStatus === '0') {
        const newUrl = token ? `${signUrl}&authToken=${token}` : signUrl;
        window.location.href = newUrl;
      }
    });
    this.fetchData();
  },

  methods: {
    fetchData() {
      const {
        businessNo,
        mobile,
        smsAuthNo,
        type,
        authToken,
      } = this.$route.query;

      this.type = type;

      services
        .getAuthConfig(businessNo, mobile)
        .then(res => {
          const {
            payed,
            smsMaxLength,
            smsSecond,
            businessSource,
            isShortMessage,
            showMessage,
          } = res.data;
          if (payed) {
            const query = { businessNo, mobile };
            this.$router.replace({ path: '/insure-result', query });
          } else {
            if (showMessage === '0') {
              if (businessSource === 'ANT') {
                const query = { businessNo, mobile, authToken };
                this.$router.replace({ path: '/proposal-term', query });
              } else {
                const query = { businessNo, mobile, authToken, businessSource };
                this.$router.replace({ path: '/proposal-sign', query });
              }
            } else if (showMessage === '1') {
              this.smsMaxLength = parseInt(smsMaxLength) || 4;
              this.smsSecond = parseInt(smsSecond) * 1000 || 120000;
              this.smsAuthNo = smsAuthNo;
              this.mobile = mobile;
            }
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },

    handleSend() {
      this.sendAuthSms();
    },

    handleFinish() {
      this.canSend = true;
    },

    sendAuthSms() {
      Toast.loading({
        message: '正在发送',
        forbidClick: true,
        duration: 0,
      });

      const { businessNo, mobile, flag } = this.$route.query;
      services.sendAuthSms(businessNo, mobile).then(res => {
        const { smsAuthenticationNo, needRealAuthFlag } = res.data;

        if (needRealAuthFlag === '0') {
          const query = { businessNo, mobile, flag };
          this.$router.replace({ path: '/proposal-sign', query });
          Toast({ message: res.head.returnMessage, duration: 3000 });
        } else {
          this.smsAuthNo = smsAuthenticationNo;
          this.canSend = false;

          if (needRealAuthFlag === '2') {
            Toast({ message: res.head.returnMessage, duration: 3000 });
          } else {
            Toast.success(res.head.returnMessage);
          }
        }
      });
    },

    checkAuthSms() {
      Toast.loading({
        message: '正在验证',
        forbidClick: true,
        duration: 0,
      });

      const codeNo = this.code;
      const authNo = this.smsAuthNo;
      const { businessNo, mobile } = this.$route.query;

      services.checkAuthSms(businessNo, mobile, authNo, codeNo).then(res => {
        this.toNextPage(res.data.feeFlag);
        Toast.clear();
      });
    },

    toNextPage(feeFlag) {
      const { query } = this.$route;
      if (!!feeFlag) {
        this.$router.push({ path: '/insure-payment', query });
      } else {
        this.$router.push({ path: '/proposal-sign', query });
      }
    },
  },

  watch: {
    code(value) {
      this.code = value.slice(0, this.smsMaxLength).replace(/\D/g, '');
      if (this.code.length === this.smsMaxLength) {
        this.checkAuthSms();
      }
    },
  },
};
</script>

<style lang="less">
.proposal-auth {
  .header {
    font-size: 20px;
    line-height: 1.5;
  }
  .auth-content {
    padding: 24px 12px;
    text-align: center;

    .auth-title {
      color: #9b9b9b;
    }

    .auth-mobile {
      margin-top: 12px;
      color: #4a4a4a;
      font-size: 24px;
    }

    .verify-code {
      margin-top: 24px;
      position: relative;

      .van-password-input {
        li {
          border-radius: 4px;
          border: 1px solid #dcdcdc;
        }
      }

      .input-code {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 0;
        outline: none;
        opacity: 0;
      }
    }

    .send-code {
      margin-top: 12px;
      padding: 12px 0;
      color: #9b9b9b;
      font-size: 16px;

      .van-count-down {
        display: inline-block;
        font-size: 16px;
      }

      &.active {
        background-image: linear-gradient(136deg, #3a91ec 0%, #426ed9 100%);
        box-shadow: 0rpx 16rpx 30rpx -20rpx #4677d9;
        width: 320px;
        height: 24px;
        margin: 48px auto;
        border-radius: 4px;
        color: #fff;
      }
    }
  }
}
</style>
